module.exports = __webpack_public_path__ + "static/38-the-future-of-work-needs-human-values-skills-and-communities-4c5b53765e5d16e7d4df937855dc67e0.jpg";